<template>
  <div class="recommend">
    <div class="recommend-wrap-title">推荐文章</div>
    <div
      v-for="item in list"
      :key="item.id"
      class="recommend-item"
      @click="() => goPostDetail(item.id)"
    >
      <div class="recommend-container">
        <p>{{item.title}}</p>
        <div>
          <span>阅读&nbsp;{{item.viewNum}}</span>
          <span>赞&nbsp;{{item.upNum}}</span>
          <span>评论&nbsp;{{item.totalReplyNum}}</span>
        </div>
      </div>
      <!-- <img class="recommend-fist-image" v-if="item.postAttachmentList && item.postAttachmentList.length" :src="item.postAttachmentList[0].url"/> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    goPostDetail(id) {
      const params = {
        id
      };
      this.$router.push({
        name: 'articleDetail',
        params
      })
    },
  }
}
</script>

<style lang="less" scoped>
.recommend {
  margin-top: 8px;
  background: #fff;
  text-align: left;
  padding: 10px 16px 16px 16px;
  display: grid;
  grid-row-gap: 12px;
}
.recommend-wrap-title {
  font-size: 14px;
  font-weight: bold;
}
.recommend-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  .recommend-container {
    flex: 1;
    overflow: hidden;
    & > p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 13px;
    }
    & > div {
      display: grid;
      grid-template-columns: max-content max-content max-content;
      grid-column-gap: 16px;
      color: #909399;
    }
  }
  .recommend-fist-image {
    width: 64px;
    border-radius: 4px;
    background: #f4f4f4;
    margin-left: 8px;
    flex-shrink: 0;
  }
}
</style>